import React from 'react';
import { MainLayout } from 'layouts/MainLayout';
import { LocationScopedSettings } from 'components/settings/LocationScopedSettings';
import { MERCHANT_MOBILE_SETTINGS } from 'config/routes';
import { InternalSettingsCard } from 'components/settings/internal/InternalSettingsCard';

export const InternalSettingsPage: React.FC = () => (
    <MainLayout
        pageName="Internal Settings"
        pageDescription="Adjust your internal settings."
        breadcrumbs={[{ label: 'Settings', url: MERCHANT_MOBILE_SETTINGS }]}
    >
        <LocationScopedSettings globalComponent={InternalSettingsCard} />
    </MainLayout>
);
